<template>
    <template v-if="loading">
        <ScaleLoader class="custom-loader" height="5rem" />
    </template>
    <div v-else>
        <Card>
            <template #title>
                <h5>{{ dialogHeader }}</h5>
            </template>

            <template #content>

                <Panel :header="`Author and ${label('Debrief')} Data`">
                    <div class="p-fluid formgrid grid">
                        <div class="col-4 md:col-2 mt-1 font-bold">
                            Name:
                        </div>
                        <div class="col-8 md:col-4 mt-1">
                            {{ debrief.author.name }} {{ debrief.author.surname }}
                        </div>
                        <div class="col-4 md:col-2 mt-1 font-bold">
                            Email:
                        </div>
                        <div class="col-8 md:col-4 mt-1">
                            {{ debrief.author.email }}
                        </div>
                        <Divider/>
                        <div class="col-4 md:col-2 mt-1 font-bold">
                            {{ label('Debrief') }} creation date:
                        </div>
                        <div class="col-8 md:col-4 mt-1">
                            {{ debrief.created_at }}
                        </div>
                        <div class="col-4 md:col-2 mt-1 font-bold">
                            Appliance / Callsign:
                            <label for="appliance">
                                <span v-if="applianceRequired" class="text-red-500 ml-1">*</span>
                            </label>
                        </div>
                        <div class="col-8 md:col-4 mt-1">

                            <Dropdown
                                id="incident_category"
                                v-model="debrief.appliance_id"
                                :options="appliances"
                                optionLabel="label"
                                optionValue="id"
                                placeholder="Appliance / Callsign"
                                class="mb-1"
                                :showClear="true"
                                :filter="true"
                                filterPlaceholder="Search..."
                            />
                        </div>
                    </div>
                </Panel>
                <Divider/>
                <Panel :header="`Create New ${label('Debrief')}`">

                    <div v-if="!editMode && (!debrief.incident_id || typeof debrief.incident_id === 'undefined')">
                        <p>
                            Please, select an <i>Incident/Exercise/Training/ or Non Operational</i> using the button provided.
                        </p>
                        <div class="text-center">
                            <IncidentPicker @incident_selected="incident_selected" :incidentCategoryLabel="incidentCategoryLabel"/>
                        </div>
                    </div>

                    <div class="p-fluid formgrid grid" v-if="typeof debrief.incident_id !== 'undefined' && debrief.incident_id > 0">

                        <div class="col-4 md:col-2 mt-2 font-bold">
                            Category:
                        </div>
                        <div class="col-8 md:col-4 mt-2">
                            {{ debrief.incident.category_txt }}
                        </div>
                        <div class="col-4 md:col-2 mt-2 font-bold">
                             Number:
                        </div>
                        <div class="col-8 md:col-4 mt-2">
                            {{ debrief.incident.incident_number }}
                        </div>
                        <div class="col-4 md:col-2 mt-2 font-bold">
                             Date:
                        </div>
                        <div class="col-8 md:col-4 mt-2">
                            {{ debrief.incident.incident_date }}
                        </div>
                        <div v-if="debrief.incident.summary" class="col-12 mt-2 font-bold">
                            Summary:
                        </div>
                        <div v-if="debrief.incident.summary" class="col-12 mt-2">
                            {{ debrief.incident.summary }}
                        </div>

                    </div>
                </Panel>

                <Divider v-if="editMode"/>
                <Panel header="Learning Outcomes" v-if="editMode && debrief.learning === 0">
                    <div class="flex justify-content-center mt-3">
                        <h4 class="learningNotIdentified">Learning not identified.</h4>
                    </div>
                </Panel>
                <Panel header="Learning Outcomes" v-if="editMode && debrief.learning === 1">

                    <div class="flex justify-content-end">
                        <Button v-if="authStore.hasPermission(UserPermission.WRITE_LEARNING_OUTCOME)" icon="pi pi-plus" label="Add Learning Outcome" @click="createLearningOutcome" />
                    </div>

                    <DataTable :value="debrief.learning_outcome" data-key="id"  responsiveLayout="scroll" class="mt-3" :loading="learningOutcomeListLoading">
                        <template #empty>No Learning Outcomes available.</template>
                        <Column field="id" header="LO id"></Column>
                        <Column field="theme.name" header="Theme"></Column>
                        <Column field="source.name" header="Source"></Column>
                        <Column field="outcome_type" header="Type"></Column>
                        <Column field="tasks" :header="label('Tasks')">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.tasks.length > 0">
                                    <ul>
                                        <li v-for="task in slotProps.data.tasks" :key="task.id">
                                            <router-link :to="`/task/form?taskId=${task.id}`">
                                                id: {{task.id}} - {{ task.title }}
                                            </router-link>
                                        </li>
                                    </ul>
                                </span>
                            </template>
                        </Column>
                        <Column field="attachments" header="Attachments"></Column>
                        <Column field="complete" header="Completed">
                            <template #body="slotProps">
                                <span v-if="slotProps.data.complete === 1" class="pi pi-key" style="color: red"></span>
                            </template>
                        </Column>
                        <Column field="actions" header="ACTION" style="min-width: 8rem">
                            <template #body="slotProps">
                                <Button v-if="slotProps.data.complete && authStore.hasPermission(UserPermission.READ_LEARNING_OUTCOME)" :loading="editingLearningOutcome === slotProps.data.id" icon="pi pi-eye" class="p-button-rounded p-button-sucess mr-2" @click="editLearningOutcome(slotProps.data.id)" />
                                <Button v-if="slotProps.data.complete === 1 && authStore.hasPermission(UserPermission.WRITE_LEARNING_OUTCOME)" :loading="editingLearningOutcome === slotProps.data.id" icon="pi pi-undo" class="p-button-rounded p-button-warning mr-2" @click="markLearningOutcomeIncomplete(slotProps.data.id)"  v-tooltip.top="'Mark as Incomplete'" />
                                <Button v-if="!slotProps.data.complete && authStore.hasPermission(UserPermission.WRITE_LEARNING_OUTCOME)" :loading="editingLearningOutcome === slotProps.data.id" icon="pi pi-pencil" class="p-button-rounded p-button-sucess mr-2" @click="editLearningOutcome(slotProps.data.id)" />
                                <Button v-if="authStore.hasPermission(UserPermission.DELETE_LEARNING_OUTCOME)" :loading="editingLearningOutcome === slotProps.data.id" icon="pi pi-trash" class="p-button-rounded p-button-danger" @click="confirmRequest(slotProps.data, deleteLearningOutcome)" />
                            </template>
                        </Column>
                    </DataTable>
                </Panel>

                <div class="flex justify-content-end mt-3">

                    <div class="flex justify-content-end" v-if="!editMode && debrief.incident_id > 0">

                        <Button :loading="saving" :disabled="saving" icon="pi pi-save" label="No learning identified" class=" mr-2" @click="saveNoLearningOutcome" />
                        <Button v-if="authStore.hasPermission(UserPermission.WRITE_LEARNING_OUTCOME)" :loading="saving" :disabled="saving" icon="pi pi-plus" label="Add Learning Outcome" class=" mr-2" @click="createLearningOutcome" />
                    </div>

                    <Button
                        v-if="editMode && debrief.incident_id > 0"
                        icon="pi pi-save"
                        label="Submit"
                        severity="success"
                        @click="saveForm"
                        class="mr-2"
                    />
                    <Button :loading="saving" icon="pi pi-times" :disabled="saving" label="Cancel" severity="danger" @click="navigateAfterDebriefSave" />
                </div>


                <div class="col-12">
                    <Accordion>
                        <AccordionTab v-if="entityLogIds.length > 0" header="Events">
                            <LogViewer :event_type="logEventTypes" :entity_ids="entityLogIds"/>
                        </AccordionTab>
                    </Accordion>
                </div>
            </template>
        </Card>
    </div>

    <Dialog v-model:visible="showEditingLearningOutcome" modal
            @hide="closeLearningOutcomePopup"
            :header="createUpdateLearningOutcomePopupTitle" :style="{ width: '100rem' }">

        <CreateUpdateLearningOutcome
            :learning-outcome="editingLearningOutcome"
            :themes="themes"
            :sources="sources"
            :popup-mode="true"
            :saving-debrief="saving"
            :debrief-id="debrief.id"
            :debrief="debrief"
            @close_popup="closeLearningOutcomePopup"
            @re-load-debrief="reloadDebrief"
        />

    </Dialog>
</template>

<script setup>

import { computed, defineProps, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { authApi } from '@/utilities/axios';
import { authStore } from '@/store/global-stores';
import { showToast } from '@/utilities/toast-handler';
import { useLabels } from '@/composables/LabelComposable';
import { UserPermission } from '@/modules/permission/enum';

const { label } = useLabels();
import { DateTime } from 'luxon';
import IncidentPicker from '@/product/ams/components/IncidentPicker.vue'
import { useConfirmRemove } from '@/composables/ConfirmComposable';
import CreateUpdateLearningOutcome from '@/product/ams/components/CreateUpdateLearningOutcome.vue';
import LogViewer from '@/product/ams/components/LogViewer.vue';
import {  debriefStore } from '../../../../../store/global-stores';

const props = defineProps({
    debriefId: {
        type: [Number, String],
        required: false,
    },
});

const { confirmRequest } = useConfirmRemove();
const route = useRoute()

const router = useRouter();

const loading = ref(true)
const saving = ref(false)

const debriefId = ref(null)
const themes = ref([])
const sources = ref([])
const appliances = ref([])

const entityLogIds = ref([])

const logEventTypes = [
    'debrief',
]

const learningOutcomeListLoading = ref(false)

const createUpdateLearningOutcomePopupTitle = ref('')

const editMode = computed(() => {
    return typeof debriefId.value !== 'undefined' && debriefId.value !== null && debriefId.value > 0;
});

const dialogHeader = computed(() => {
    return editMode.value ? `Edit ${label('Debrief')}` : `Add ${label('Debrief')}`;
});

const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

const currentUser = computed(() => {
    return authStore.loggedUser;
});

const debrief = ref({
    id: null,
    author: {
        name: null,
        surname: null,
        email: null,
    },
    incident: {
        id: null,
        incident_number: null,
        category: null,
        category_txt: null,
        incident_date: null,
        incident_type_id: null,
        summary: null,
    },
    created_at: '',
    incident_id: null,
    learning_outcome: [],
    company_id: null,
    appliance_id: null,
    learning: null,
    complete: false,
})

const incidentCategoryLabel = ref("Category");


const applianceRequired = ref(false);

const editingLearningOutcome = ref(null)
const showEditingLearningOutcome = ref(false)

function deleteLearningOutcome(learningOutcomeId) {
    editingLearningOutcome.value = learningOutcomeId
    // console.log('deleteLearningOutcome', learningOutcomeId)

    return authApi
        .delete(`/v2/learning-outcome/${learningOutcomeId}?companyId=${company_id.value}`)
        .then(() => {
            editingLearningOutcome.value = null

            //debrief.learning_outcome

            const index = debrief.value.learning_outcome.findIndex(item => item.id === learningOutcomeId)

            if (index > -1) { // only splice array when item is found
                debrief.value.learning_outcome.splice(index, 1); // 2nd parameter means remove one item only
            }
        })
        .catch((error) => {
            editingLearningOutcome.value = null
            showToast(error, 'Failed to delete the LO');
        })
}

function editLearningOutcome(learningOutcomeId) {
    createUpdateLearningOutcomePopupTitle.value = 'Edit Learning Outcome'
    editingLearningOutcome.value = learningOutcomeId
    showEditingLearningOutcome.value = true
}

function closeLearningOutcomePopup() {
    // console.log('closing')
    editingLearningOutcome.value = null
    showEditingLearningOutcome.value = false
}

function saveDebrief() {

    if (applianceRequired.value && !debrief.value.appliance_id) {
        showToast({ severity: 'warn', summary: 'Alert' }, 'Callsign dropdown is required');
        saving.value = false;
        return;
    }

    debrief.value.company_id = company_id.value

    if (debrief.value.id && debrief.value.id > 0) {
        return authApi
            .patch(`/v2/debrief/${debrief.value.id}`, debrief.value)
            .catch((error) => {
                showToast(error, `Failed to save the ${label('Debrief').toLowerCase()}`);
            })
            .then((response) => {
                if (response.statusCode === 200) {
                    if (Object.hasOwn(response, 'data')) {
                        parseDebriefData(response)
                    }
                }
            })
    } else {
        return authApi
            .post(`/v2/debrief`, debrief.value)
            .catch((error) => {
                showToast(error, `Failed to save the ${label('Debrief').toLowerCase()}`);
            })
            .then((response) => {
                if (response.statusCode === 201) {
                    // console.log('saveDebrief::update', response)
                    if (Object.hasOwn(response, 'data')) {
                        parseDebriefData(response)
                    }
                }
            })
    }
}

function navigateAfterDebriefSave() {
    // Submit-only users (no read_debrief) cannot open the debrief list
    if (authStore.hasPermission(UserPermission.READ_DEBRIEF)) {
        router.push({ name: 'Debriefs' })
    } else {
        router.push({ name: 'Home' })
    }
}

function saveForm() {
    saving.value = true
    saveDebrief().then(() => {
        saving.value = true
        navigateAfterDebriefSave()
    })
}

function saveNoLearningOutcome() {
    debrief.value.learning = 0
    saving.value = true
    saveDebrief().then(() => {
        saving.value = true
        navigateAfterDebriefSave()
    })
}

function createLearningOutcome() {

    if (!editMode.value) {
        debrief.value.learning = 1

        saving.value = true

        saveDebrief().then(() => {
            saving.value = false

            router.replace({ path: 'createUpdate', query: { debriefId: debrief.value.id }})

            showEditingLearningOutcome.value = true
        })
    } else {
        saving.value = true
        saveDebrief().then(() => {
            saving.value = false
            showEditingLearningOutcome.value = true
        })
    }

    createUpdateLearningOutcomePopupTitle.value = 'Create Learning Outcome'

}

function parseCategory(categoryId) {
    let categoryTxt = ''

    categoryId = parseInt(categoryId)

    switch (categoryId) {
        case 1:
            categoryTxt = 'Incident'
            break
        case 2:
            categoryTxt = 'Exercise'
            break
        case 3:
            categoryTxt = 'Training'
            break
        case 4:
            categoryTxt = 'Non Operational'
            break
    }

    return categoryTxt;
}

function parseDebriefData(response) {
    if (Object.hasOwn(response, 'data')) {

        const debriefData = response.data

        if (Object.hasOwn(debriefData, 'id')) {
            debriefId.value = debriefData.id
            debrief.value.id = debriefData.id
            entityLogIds.value.push(props.debriefId)
        }

        if (Object.hasOwn(debriefData, 'incident_id')) {
            debrief.value.incident_id = debriefData.incident_id
            entityLogIds.value.push(debriefData.incident_id)
        }

        if (Object.hasOwn(debriefData, 'appliance_id')) {
            debrief.value.appliance_id = debriefData.appliance_id
        }

        if (Object.hasOwn(debriefData, 'learning')) {
            debrief.value.learning = debriefData.learning
        }

        if (Object.hasOwn(debriefData, 'author')) {
            debrief.value.author = debriefData.author
        }

        debrief.value.created_at = DateTime.fromISO(debriefData.created_at).setLocale('en-GB').toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })

        // console.log('~~~ debriefData', debriefData)
        // console.log('~~~ debriefData.learning_outcome', debriefData.learning_outcome)

        if (Object.hasOwn(debriefData, 'learning_outcome')) {
            debrief.value.learning_outcome = []

            debriefData.learning_outcome.forEach((learningOutcome) => {
                // console.log('learningOutcome', learningOutcome)
                let learningOutcomeData = {
                    id: null,
                    theme: null,
                    source: null,
                    outcome_type: null,
                    complete: null,
                    attachments: 0,
                    tasks: []
                }

                if (Object.hasOwn(learningOutcome, 'id')) {
                    learningOutcomeData.id = learningOutcome.id

                    entityLogIds.value.push(learningOutcome.id)
                }

                if (Object.hasOwn(learningOutcome, 'attachments')) {
                    learningOutcomeData.attachments = learningOutcome.attachments.length
                }

                if (Object.hasOwn(learningOutcome, 'theme')) {
                    learningOutcomeData.theme = learningOutcome.theme
                }

                if (Object.hasOwn(learningOutcome, 'complete')) {
                    learningOutcomeData.complete = learningOutcome.complete
                }

                if (Object.hasOwn(learningOutcome, 'source')) {
                    learningOutcomeData.source = learningOutcome.source
                }

                if (Object.hasOwn(learningOutcome, 'task')) {
                    learningOutcomeData.tasks = learningOutcome.task
                }

                if (Object.hasOwn(learningOutcome, 'outcome_type')) {
                    switch(parseInt(learningOutcome.outcome_type)) {
                        case 1:
                            learningOutcomeData.outcome_type = 'Local Issue'
                            break;
                        case 2:
                            learningOutcomeData.outcome_type = 'Service Wide'
                            break;
                        case 3:
                            learningOutcomeData.outcome_type = 'Notable Practice'
                            break;
                    }
                }

                debrief.value.learning_outcome.push(learningOutcomeData)
            })
        }

        if (Object.hasOwn(debriefData, 'incident')) {
            const incident = debriefData.incident

            if (Object.hasOwn(incident, 'id')) {
                debrief.value.incident.id = incident.id
            }

            if (Object.hasOwn(incident, 'category')) {
                debrief.value.incident.category_txt = parseCategory(incident.category)
            }

            if (Object.hasOwn(incident, 'incident_date')) {

                let incidentDate = DateTime.fromSQL(incident.incident_date)

                if (incidentDate.invalid) {
                    incidentDate = DateTime.fromISO(incident.incident_date)
                }

                debrief.value.incident.incident_date = incidentDate.setLocale('en-GB').toLocaleString({
                    weekday: 'short',
                    month: 'short',
                    day: '2-digit',
                    year: 'numeric',
                })
            }

            if (Object.hasOwn(incident, 'incident_number')) {
                debrief.value.incident.incident_number = incident.incident_number
            }

            if (Object.hasOwn(incident, 'incident_type_id')) {
                debrief.value.incident.incident_type_id = incident.incident_type_id
            }

            if (Object.hasOwn(incident, 'incident_type_id')) {
                debrief.value.incident.incident_type_id = incident.incident_type_id
            }

            if (Object.hasOwn(incident, 'summary')) {
                debrief.value.incident.summary = incident.summary
            }
        }
    }
}

function reloadDebrief() {
    // console.log('reloadDebrief', debrief.value.id)

    //close the LO popup
    showEditingLearningOutcome.value = false
    editingLearningOutcome.value = null

    loadDebrief(debrief.value.id)
}

function loadDebrief(debriefId) {
    learningOutcomeListLoading.value = true

    authApi.get(`/v2/debrief/${debriefId}?companyId=${company_id.value}`)
        .then( async (response) => {
            learningOutcomeListLoading.value = false
            // default value equal to true. Not set elsewhere
            loading.value = false

            if (response.statusCode === 200) {
                parseDebriefData(response)
            }

        }).catch((error) => {
            learningOutcomeListLoading.value = false

            showToast(error, `Failed to load the ${label('Debrief')}`).then(() => {
                setTimeout(() => {router.go(-1)}, 2000)

            });
        });
}

function loadAppliances() {
    authApi.get(`/v2/appliance?paginate=false&company_id=${company_id.value}`)
        .then( async (response) => {
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    const sorted = response.data.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                    sorted.forEach((item) => {
                        appliances.value.push(parseItems(item))
                    })
                }
            }

        }).catch((error) => {
        showToast(error, 'Failed to load the Appliances list');
    });
}

watch(() => route.query, () => {

    if (Object.hasOwn(route, 'query')) {
        if (Object.hasOwn(route.query, 'debriefId')) {
            loadDebrief(route.query.debriefId)
        }
    }
})

onMounted(async () => {
    entityLogIds.value = []
    loadThemes(true)
    loadSources()
    loadAppliances()
    await debriefStore.fetchPreference().then((response) => {
        applianceRequired.value = response.callsign_required;
    })

    if (Object.hasOwn(props, 'debriefId') && typeof props.debriefId !== 'undefined') {
    //if (Object.prototype.hasOwnProperty.call(queryParams, 'debriefId')) {
        debriefId.value = props.debriefId

        loadDebrief(props.debriefId)

    } else {
        loading.value = false

        debrief.value.author = currentUser.value
        debrief.value.created_at = DateTime.now().setLocale('en-GB').toLocaleString({
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })
    }
})

// Recursive function to parse incident types and property types
function parseItems(item) {
    let result = {}

    if (Object.hasOwn(item, 'id') && Object.hasOwn(item, 'name')) {
        result.id = item.id
        result.label = item.name

        if (Object.hasOwn(item, 'children') && item.children.length > 0) {
            result.children = []

            const sortedChildren = item.children.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            sortedChildren.forEach((children) => {
                result.children.push(parseItems(children))
            })
        }
    }

    return result
}

function loadThemes(onlyVisible = false) {
    authApi.get(`/v2/themes?paginate=false&company_id=${company_id.value}&only_visible=${onlyVisible}`)
        .then( async (response) => {
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    response.data.forEach((item) => {
                        themes.value.push(parseItems(item))
                    })
                }
            }

        }).catch((error) => {
        showToast(error, 'Failed to load the Theme list');
    });
}

function loadSources() {
    authApi.get(`/v2/sources?paginate=false&company_id=${company_id.value}`)
        .then( async (response) => {
            if (response.statusCode === 200) {
                if (Object.hasOwn(response, 'data')) {
                    response.data.forEach((item) => {
                        sources.value.push(parseItems(item))
                    })
                }
            }

        }).catch((error) => {
        showToast(error, 'Failed to load the Sources list');
    });
}

function incident_selected(incident) {
    debrief.value.incident_id = incident.id
    debrief.value.incident = incident
    debrief.value.incident.category_txt = parseCategory(incident.category)
}


// New function to mark a learning outcome as incomplete
function markLearningOutcomeIncomplete(learningOutcomeId) {
    editingLearningOutcome.value = learningOutcomeId; // Set loading state for the specific row
        authApi.patch(`/v2/learning-outcome/${learningOutcomeId}/mark-incomplete`, {
            company_id: company_id.value
        })
        .then(() => {   
            showToast({ severity: 'success', summary: 'Success' }, 'Marked as incomplete successfully');
            reloadDebrief(); // Reload the debrief data to reflect the change
        })
        .catch((error) => {
            let message = error?.response?.data?.message || error.message || 'Failed to mark Learning Outcome as incomplete';
            showToast({ severity: 'error', summary: 'Error', detail: message });
        })
        .finally(() => {
            editingLearningOutcome.value = null; // Clear loading state
        });
}

</script>

<style scoped>
.learningNotIdentified {
    color: rgb(7, 150, 7)
}
</style>
